import React, { useState } from 'react';
import { Button, Modal, Spinner, Image, Row, Col, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import coffee from './coffe.jpg';

const About = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [backendMessage, setBackendMessage] = useState('');
  const [error, setError] = useState(null);

  const handleShow = async () => {
    setShowModal(true);
    setLoading(true);
    setError(null);
    setBackendMessage('');

    try {
      const response = await fetch('https://iiuccsc-ctf.vercel.app/api/about', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setBackendMessage(data.message || 'No message received');
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setBackendMessage('');
    setError(null);
  };

  return (
    <div className="container py-5 my-5">
      <Row className="align-items-center g-5">
        {/* Left Side: Image with stylized border */}
        <Col lg={6} className="text-center position-relative">
          <div className="about-image-wrapper">
             <Image
              src={coffee}
              alt="Coffee cup"
              className="img-fluid rounded-4 shadow-lg main-about-img"
              style={{ maxHeight: '500px', width: '100%', objectFit: 'cover' }}
            />
          </div>
        </Col>

        {/* Right Side: Text Content */}
        <Col lg={6}>
          <div className="ps-lg-4">
            <h6 className="text-uppercase fw-bold text-warning mb-2" style={{ letterSpacing: '2px' }}>
              Our Story
            </h6>
            <h1 className="display-4 fw-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#3d2b1f' }}>
              Passion for the Perfect Brew
            </h1>
            
            <p className="lead text-muted mb-4">
              Welcome to <strong>Campus Grind</strong>. We are more than just a cafe; we are a community of coffee enthusiasts dedicated to the art of the perfect cup.
            </p>
            
            <div className="mb-4">
              <p className="mb-2">✨ <strong>Handpicked Beans:</strong> Sourced from the finest farms worldwide.</p>
              <p className="mb-2">🥐 <strong>Daily Freshness:</strong> Homemade pastries and desserts baked every morning.</p>
              <p className="mb-2">🛋️ <strong>Warm Atmosphere:</strong> The perfect spot to study, meet, or relax.</p>
            </div>

            <Button 
              variant="dark" 
              className="btn-lg px-5 py-3 rounded-pill shadow-sm hover-elevate mt-3"
              style={{ backgroundColor: '#5d4037', border: 'none' }}
              onClick={handleShow}
            >
              Get More Info
            </Button>
          </div>
        </Col>
      </Row>

      {/* Styled Modal */}
      <Modal show={showModal} onHide={handleClose} centered size="md" className="about-modal">
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold" style={{ color: '#5d4037' }}>
            Campus Grind Secrets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="grow" variant="warning" role="status" />
              <p className="mt-3 text-muted">Consulting the Barista...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger text-center">
              <p className="mb-0">{error}</p>
            </div>
          ) : (
            <div className="text-center">
              <Card className="border-0 bg-light rounded-4 overflow-hidden">
                <Card.Body className="p-4">
                  <h5 className="mb-3 text-secondary">Special Message</h5>
                  <Card.Text className="fs-5 italic" style={{ fontStyle: 'italic' }}>
                    "{backendMessage}"
                  </Card.Text>
                  <hr />
                  <Image
                    src="https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=600&q=80"
                    alt="Cafe interior"
                    fluid
                    className="rounded-3 mt-2 shadow-sm"
                  />
                </Card.Body>
              </Card>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" onClick={handleClose} className="rounded-pill px-4">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default About;